import { Button, Typography } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { BREACH_CHECKED, MainStyles } from '../constants';
import { CalculateScannedCount } from '../helpers/calculateScanCount';
import { UpdateVialBody } from '../../../services/medicService';
import { omsWebConfig } from '../../../services/config';
import { documentsCollectionPending } from '../Plugs/CollectionPrereqs';

const PartnerCampCTA = ({
  success, parentData, documentData, setUpdate,
  update, setSuccess,
  taskId, setErrorAlert,
  setCloseAlert, campId,
  emedicId, token,
}) => (
  <Button
    sx={!success ? MainStyles.SubmitButton : MainStyles.DoneButton}
    onClick={() => {
      const { orders = [] } = parentData;
      if (!success) {
        const barcodeCount = CalculateScannedCount(orders);
        if (barcodeCount >= parentData?.total_vials) {
          if (documentsCollectionPending(documentData)) {
            setErrorAlert([true, 'Please fill required documents!']);
            return;
          }
          if (parentData) {
            const newData = parentData;
            newData.form_completed = true;
            UpdateVialBody(taskId, newData, campId).then(() => {
              setUpdate(!update);
              setSuccess(true);
              if (taskId) {
                localStorage.removeItem(BREACH_CHECKED + taskId);
              }
              window.location.href = `${omsWebConfig()}/emedics/${emedicId}/camps/${campId}?token=${token}&isCompleted=true&orderId=${orders?.[0]?.id}`;
              window.scrollTo(0, 0);
            }).catch(() => {
              setErrorAlert([true, 'Error submitting form']);
            });
          }
        } else {
          window.location.href = `${omsWebConfig()}/emedics/${emedicId}/camps/${campId}?token=${token}`;
        }
      } else {
        setCloseAlert(true);
        window.location.href = `${omsWebConfig()}/emedics/${emedicId}/camps/${campId}?token=${token}`;
      }
    }}
  >
    <Typography
      sx={!success ? MainStyles.SubmitText : MainStyles.DoneText}
    >
      {!success ? 'Proceed' : 'Done'}
    </Typography>
  </Button>
);

PartnerCampCTA.propTypes = {
  success: PropTypes.bool,
  parentData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  documentData: PropTypes.object,
  setUpdate: PropTypes.func,
  update: PropTypes.bool,
  setSuccess: PropTypes.func,
  taskId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setErrorAlert: PropTypes.func,
  setCloseAlert: PropTypes.func,
  campId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  emedicId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  token: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PartnerCampCTA;
